"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const convertBurstTimeToEpochTime_1 = require("./convertBurstTimeToEpochTime");
exports.convertBurstTimeToDate = (burstTimestamp) => {
    return new Date(convertBurstTimeToEpochTime_1.convertBurstTimeToEpochTime(burstTimestamp));
};
//# sourceMappingURL=convertBurstTimeToDate.js.map